<script lang="ts" setup>

interface Prop {
  tag?: string
  root?: number
  size?: Size
  placement?: Placement
}

const props = defineProps<Prop>()

const config: Record<Size, string> = {
  xs: 'text-[8px] leading-[14px]',
  sm: 'text-[10px] leading-[18px]',
  md: 'text-[12px] leading-[20px]',
  base: 'text-[14px] leading-[22px]',
  lg: 'text-[16px] leading-[24px]',
  '2lg': 'text-[16px] leading-[24px] font-[500]',
  xl: 'text-[18px] leading-[24px] font-[500]',
  '2xl': 'text-[20px] leading-[28px] font-[500]',
  '3xl': 'text-[22px] leading-[30px] font-[500]',
  h5: 'text-[20px] leading-[28px] font-[500]',
  h4: 'text-[22px] leading-[30px] font-[500]',
  h3: 'text-[24px] leading-[32px] font-[500]',
  h2: 'text-[30px] leading-[40px] font-[500]',
  h1: 'text-[48px] leading-[56px] font-[900]'
}

const size = computed(() => config[props.size ?? 'base'])

const align = computed(() => {
  return {
    left: 'text-left',
    center: 'text-center',
    right: 'text-right',
  }[props.placement ?? 'center']
})

const tag = props.tag ?? computed(() => /^h\d$/.test(props.size!) ? props.size : 'div')

</script>

<template>
  <component :is="tag" :class="[align, size]">
    <slot></slot>
  </component>
</template>

<style lang="scss" scoped></style>
